import { Component, Input, OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';

@Component({
  selector: 'checkbox-question',
  template:`<div [formGroup]="form">
  <kendo-formfield>
          <div class="k-form-field-checkbox-wrap">
            <input
              kendoCheckBox
              [id]="question.key"
              type="checkbox"
              [formControlName]="question.key"
            />
            <kendo-label
              class="k-checkbox-label"
              [for]="question.key"
              [text]="question.label"
            ></kendo-label>
          </div>
          <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
          <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
        </kendo-formfield>
</div>`
})
export class CheckboxFormQuestionComponent  implements OnChanges {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;

  errorRequired: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) {
    if(changes.question.firstChange){ 
      this.errorRequired = changes.question.currentValue.errors.find( ({ key }) => key === 'requiredTrue' )
    }
  }

}